import { Controller, FieldError, useFormContext } from 'react-hook-form';
import { get } from 'lodash';
import { DropdownMenu, DropdownMenuProps } from '../DropdownMenu';
import { FormControl } from './FormControl';

export function FormDropdownMenu({
  name,
  className,
  label,
  dropdownMenuClassName,
  ...dropdownProps
}: {
  name: string;
  className?: string;
  label?: string;
  dropdownMenuClassName?: string;
} & DropdownMenuProps) {
  const {
    control,
    formState: { errors },
    register,
  } = useFormContext();
  const error = get(errors, name);

  const { onChange, onBlur, name: formName, ref } = register(name);

  return (
    <FormControl
      ref={ref}
      label={label}
      className={className}
      error={error as FieldError}
      onChange={onChange}
      onBlur={onBlur}
      name={formName}
    >
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <DropdownMenu
            {...dropdownProps}
            className={dropdownMenuClassName}
            error={error}
            {...field}
          >
            {dropdownProps.children}
          </DropdownMenu>
        )}
      />
    </FormControl>
  );
}
